import { create } from 'zustand';

const DEFAULT_LOGO_URL = '/pwa-192x192.png';

export const useRuntimeBrandStore = create((set) => ({
  logoUrl: DEFAULT_LOGO_URL,
  brandName: '',
  businessAddress: '',
  businessPhone: '',
  socialLinks: null,
  businessEmail: '',
  supportPhone: '',
  whatsappNumber: '',
  privacyPolicy: '',
  termsAndConditions: '',
  aboutUs: '',
  faq: '',
  poweredBy: null,
  setLogoUrl: (logoUrl) => set({ logoUrl: logoUrl || DEFAULT_LOGO_URL }),
  setBrandName: (brandName) => set({ brandName: brandName || '' }),
  setBusinessAddress: (businessAddress) => set({ businessAddress: businessAddress || '' }),
  setBusinessPhone: (businessPhone) => set({ businessPhone: businessPhone || '' }),
  setSocialLinks: (socialLinks) => set({ socialLinks: socialLinks || null }),
  setBusinessEmail: (businessEmail) => set({ businessEmail: businessEmail || '' }),
  setSupportPhone: (supportPhone) => set({ supportPhone: supportPhone || '' }),
  setWhatsappNumber: (whatsappNumber) => set({ whatsappNumber: whatsappNumber || '' }),
  setPrivacyPolicy: (privacyPolicy) => set({ privacyPolicy: privacyPolicy || '' }),
  setTermsAndConditions: (termsAndConditions) =>
    set({ termsAndConditions: termsAndConditions || '' }),
  setAboutUs: (aboutUs) => set({ aboutUs: aboutUs || '' }),
  setFaq: (faq) => set({ faq: faq || '' }),
  setPoweredBy: (poweredBy) => set({ poweredBy: poweredBy || null }),
}));
